import * as React from 'react';

import PropTypes from 'prop-types';

import { LONG_DATETIME_DISPLAY, formatDateTimeDisplay } from 'js/utils/DateTimeUtils';


class Time extends React.Component {
  static propTypes = {
    time: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)]).isRequired,
    format: PropTypes.string,
  };

  static defaultProps = {
    format: LONG_DATETIME_DISPLAY,
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'time' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    const { time, format } = this.props;
    return <span>{formatDateTimeDisplay(time, format)}</span>;
  }
}

export default Time;
